<template>
  <div class="mainte">
    <img class="logo" src="../assets/ran-logo.png" />
    <p class="msg">Web Service in Under Maintenance!</p>
  </div>
</template>

<script>
export default {
  name : "MaintenancePageLayout",
  created () {
    this.$q.loading.show()
    this.$q.loading.hide();
  }
}
</script>
<style lang="scss">
  .mainte {
    height:100vh;

    .logo {
      display: block;
      margin-left: auto;
      margin-right: auto;
      width: 45%;
    }

    .msg {
      text-align: center;
      color: white;
      font-size: 50px;
      text-shadow: 2px 2px #000000;
    }
  }
</style>
